import { Option } from '@sapphire/result';

import { MAX_CPI_THRESHOLD } from '../../constants/high-cpi-confirmation.constants';
import type { Nullable } from '@ps/utils';

/**
 * Whether a CPI is high enough that the buyer has to confirm it before it can
 * be applied — every cost incurred at this rate is billable, so a mistyped
 * value is expensive rather than merely wrong.
 *
 * The one place the threshold is compared, so the drawer's warning styling and
 * its Apply gate can never disagree about which values count as high.
 */
export function isHighCpi(cpi: Nullable<number>): cpi is number {
  return Option.from(cpi).mapOr(false, (value) => value > MAX_CPI_THRESHOLD);
}
